import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { DECK_ADMIN_URL } from "./deckAdminUrl";
import {
  InsertSubstructureMaterialClassBody,
  SearchSubstructureMaterialClassesResponse,
  UpdateSubstructureMaterialClassBody,
} from "./types/substructureMaterialClasses";

export const useDeckSubstructureMaterialClassesApi = () => {
  const crud = createAdminCrudApi<
    SearchSubstructureMaterialClassesResponse,
    InsertSubstructureMaterialClassBody,
    UpdateSubstructureMaterialClassBody
  >(useApi(), DECK_ADMIN_URL, "substructure_material_classes");

  return {
    useDeckSubstructureMaterialClasses: crud.useSearch,
    getDeckSubstructureMaterialClasses: crud.search,
    insertDeckSubstructureMaterialClass: crud.insert,
    updateDeckSubstructureMaterialClass: crud.update,
    deleteDeckSubstructureMaterialClass: crud.remove,
  };
};

export default useDeckSubstructureMaterialClassesApi;
